import { useState, useEffect } from 'react';
import axios from 'axios';

export default function useExchangeRate() {
  const [rates, setRates] = useState({ AED: 1, USD: 3.6725 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://open.er-api.com/v6/latest/AED')
      .then(r => {
        setRates({
          AED: 1,
          USD: 1 / r.data.rates.USD,
        });
        setLoading(false);
      })
      .catch(() => {
        setRates({ AED: 1, USD: 3.6725 });
        setLoading(false);
      });
  }, []);

  const toAED = (amount, currency) => {
    if (currency === 'AED') return amount;
    if (currency === 'USD') return amount * rates.USD;
    return amount;
  };

  const formatAED = (amount, currency) => {
    const aed = toAED(amount, currency);
    return Math.round(aed);
  };

  return { rates, loading, toAED, formatAED };
}
